<main>
  <h2>Support & Funding</h2>
  <h3>Turn funded agreements into streamed funds.</h3>
  <div class="cardrow">
    <div class="card grantforproposal-screenshot">
      <div class="text">
        <h4 class="cardtitle">Grant RFP & proposals</h4>
        <p>Grant requests for proposals and proposals.</p>
      </div>
    </div>
    <div class="card fundedcontributors-screenshot">
      <div class="text">
        <h4 class="cardtitle">Funded contributors</h4>
        <p>Pay your contributors.</p>
      </div>
    </div>
    <div class="card fundedissues-screenshot">
      <div class="text">
        <h4 class="cardtitle">Funded issues</h4>
        <p>Offer money to fix issues.</p>
      </div>
    </div>
  </div>
</main>
